import { StatementList } from '../statements/types';
import { BaseState } from '../types';

// Actions

export enum FileGenerationTypes {
  FileGenerationRequest = '@auth/FILE_GENERATION_REQUEST',
  FileGenerationSuccess = '@auth/FILE_GENERATION_SUCCESS',
  FileGenerationFailure = '@auth/FILE_GENERATION_FAILURE',
}

export type SupportedFilesType = 'csv' | 'pdf';

export interface FileGenerationRequestActionPayload {
  statements: StatementList;
  fileType: SupportedFilesType;
  previousDayValue: string;
  periodStart: string;
}

// State

export type FileGenerationState = BaseState;
